import React, { useMemo } from 'react';
import VoxelTooltipShort from '../../../components/voxel/Tooltip/VoxelTooltipShort';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { useProjectDefaults } from '../../../logic/otherUtilities/useProjectDefaults';
import { ProjectSettingsMenuChoices } from '../../ProjectSettingsPage/ProjectSettingsPage';
import { ProjectTabChoices } from '../ProjectPage';
import GotToEditLink from './GotToEditLink';

export interface LanguageIndicatorProps {
  project: ProjectGq;
}

export const LanguageIndicator: React.FC<LanguageIndicatorProps> = ({ project }) => {
  // Settings
  const projectDefaults = useProjectDefaults(project);
  const langIsMixed = project.serpLanguageId !== project.defaultLanguageId;

  // Presented name
  const keywordLanguageName = projectDefaults?.volumeLanguage?.code ?? 'All languages';
  const serpLanguageName = projectDefaults?.serpLanguage?.code;
  let presentedLanguage = keywordLanguageName;
  if (langIsMixed) {
    presentedLanguage += ` (${serpLanguageName})`;
  }

  // Serp required issue
  const serpLanguageRequired = useMemo(
    () => !projectDefaults?.volumeLanguage?.name && !projectDefaults?.serpLanguage?.name,
    [projectDefaults]
  );

  // Url
  const settingsUrl = `/${project.id}/${ProjectTabChoices.Settings}/${ProjectSettingsMenuChoices.DataCollectionSettings}#language`;

  return (
    <VoxelTooltipShort message="Edit keyword language">
      <GotToEditLink href={settingsUrl} hasError={serpLanguageRequired} className="h-7">
        {presentedLanguage}
      </GotToEditLink>
    </VoxelTooltipShort>
  );
};

export default LanguageIndicator;
